import PropTypes from 'prop-types';
import {
  checkImageUrl,
  getPortfolioThumbnail,
  isPortfolioThumbnailPageScreenshot,
} from '@hiredigital/lib/helpers/utils';
import Styles from './PortfolioItem.module.scss';
import Image from 'next/image';
import classNames from 'classnames';

const PortfolioItem = ({
  item,
  handleClass,
  onEdit,
  onPreview,
  showActions = true,
  showTags = true,
  showExcerpt = true,
  previewOnItemClick = false,
}) => {
  const getItemCases = (item) => item?.caseItems || [];

  const itemThumbnail = getPortfolioThumbnail(item);
  const itemThumbnailIsPageScreenshot = isPortfolioThumbnailPageScreenshot(item);
  const itemImage = checkImageUrl(itemThumbnail);

  const title = item.title || getItemCases(item)?.[0]?.title || '';

  const handlePreview = () => onPreview?.(item);

  return (
    <div className={Styles.container} onClick={handlePreview} style={{ cursor: 'pointer' }}>
      <div style={{ position: 'relative' }}>
        {item.showThumbnail && itemImage ? (
          <Image
            className={classNames(
              Styles.thumbnail,
              itemThumbnailIsPageScreenshot && Styles.pageScreenshot
            )}
            alt=''
            src={itemThumbnail}
            fill
            sizes='(max-width: 700px) 578px, (max-width: 1280px) 423px, 271px'
          />
        ) : (
          <div className={Styles.thumbnailPlaceholder} />
        )}

        <div className={Styles.details}>
          {(item?.publication?.name || item?.publication?.url) && (
            <p
              className={Styles.label}
              dangerouslySetInnerHTML={{
                __html: item?.publication?.name || item?.publication?.url,
              }}></p>
          )}
          <h3 className={Styles.title}>{title || `Untitled Content`}</h3>
        </div>
      </div>
    </div>
  );
};

PortfolioItem.propTypes = {
  item: PropTypes.object,
  onPreview: PropTypes.func,
};

export default PortfolioItem;
